import { render } from "./SignUpKyc.vue?vue&type=template&id=0f7a754c&scoped=true&ts=true"
import script from "./SignUpKyc.vue?vue&type=script&lang=ts"
export * from "./SignUpKyc.vue?vue&type=script&lang=ts"

import "./SignUpKyc.vue?vue&type=style&index=0&id=0f7a754c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7a754c"]])

export default __exports__